import { toastr } from "../_components/toastr/toastr";
import { accountService } from "../_services/accounts.service";

export function handleResponse(response: Response) {
    return response.text().then(text => {
        let data;

        try {
            data = text && JSON.parse(text);
        } catch (e) {
            data = text;
        }

        if (!response.ok) {
            if (response.status === 401) {
                accountService.logout();
            }
            if(response.status === 403){
                return Promise.reject(data || "Access to this centre is not allowed from your current network.");
            }

            return Promise.reject(data);
        }
        return data;
    });
}

export function handleErrorResponse(err: any) {
    console.log(err)
    toastr.error((err && err.response && err.response.data) ? err.response.data : err.Message || err.message || err.title || err || "Something went wrong. Please try again later");
}

export function handleErrorResponseAxios(err: any) {

    toastr.error((err && err.response ? err.response.data : null) || err.Message || err.message || err.title || err || "Something went wrong. Please try again later");
}